const themeStyles = colors => {
  const styles = {
    container: {
      width: '1128px',
      alignSelf: 'center',
      marginTop: 'auto',
      marginBottom: 'auto',
      borderRadius: '4px',
      backgroundColor: colors.white,
      boxShadow: '0 5px 10px 0 rgba(0,0,0,0.06)',
      display: 'flex'
    },
    leftContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    footer: {
      container: {
        flex: 1
      }
    },
    childContainer: {
      flex: 5.75
    },
    childContainerHorizon: {
      padding: '37px 20px 29px 90px'
    },
    rightContainer: {
      position: 'relative',
      flex: 1,
      marginBottom: -5
    },
    heroImageContainer: {
      height: '100%'
    },
    heroImage: {
      width: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4
    },
    logo: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 202,
      height: 67,
      objectFit: 'contain',
      filter: 'brightness(10) opacity(0.5)',
      marginTop: -2.5
    }
  }
  return styles
}

export default themeStyles
